import React, { useContext } from 'react';
import UserContext from '../hooks/UserContext';
import { Outlet, Navigate, useLocation } from "react-router-dom";

const PrivateRoute = () => {
    const {pathname: continueTo } = useLocation();
    const { user } = useContext(UserContext);
    if (!user) return <Navigate to = '/login' state = { { continueTo } }  replace = {true}/>;
    else if (user.forceLogin) return <Navigate to = '/login' state = { { continueTo} } replace = {true} />;
    else if (user.forcePWChange) return <Navigate to = '/change-password'  state = { {continueTo, message: 'You must change your password' } } replace = {true} />;
    else return <Outlet />;
}

export default PrivateRoute;